import { environment } from "../config/environment";
import { getFromBackendAPI } from "./api.service";

export interface OfficeMemberDto {
  email: string;
  displayName?: string;
}

export interface UserRoleResponse {
  role: string;
}

const baseUrl = () =>
  `${environment.api.baseUrl}${environment.api.endpoints.users}`;

export async function getUserRole(): Promise<string> {
  const response = await getFromBackendAPI<UserRoleResponse>(
    `${baseUrl()}/me/role`
  );
  return response.role;
}

export async function getOfficePartners(): Promise<OfficeMemberDto[]> {
  return await getFromBackendAPI<OfficeMemberDto[]>(
    `${baseUrl()}/me/office-partners`
  );
}

export async function getOfficeManagers(): Promise<OfficeMemberDto[]> {
  return await getFromBackendAPI<OfficeMemberDto[]>(
    `${baseUrl()}/me/office-managers`
  );
}
